import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { DeputateBuildingsTable } from '../../../../components/Buildings/Tables/DeputateBuildingsTable';
import { Page } from '../../../../components/Page/Page';
import { RoomsTable } from '../../../../components/Rooms/Tables/RoomsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const SetupRoomsAndBuildings = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('rooms.title', { count: 2 }),
            id: 'rooms',
            content: <RoomsTable />,
          },
          {
            trigger: t('buildings.title', { count: 2 }),
            id: 'buildings',
            content: <DeputateBuildingsTable />,
          },
        ]}
      />
    </Page>
  );
};
